if (!customElements.get('bottom-sheet')) {
    customElements.define(
        'bottom-sheet',
        class BottomSheet extends HTMLElement {
            constructor() {
                super();
                this.sheetId = this.dataset.sheetId
                this.richContext = this.dataset.richContent
                this.title = this.dataset.title
                this.subtitle = this.dataset.subtitle
                this.closeText = this.dataset.closeText
                this.container = this
                this.bottomSheet = null
            }

            createCloseButton() {
                const closeButton = document.createElement('button')
                closeButton.classList.add('modal-popup__close-icon')
                closeButton.innerHTML = `
                 <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    class="icon icon-close"
                    fill="none"
                    viewBox="0 0 18 17"
                    >
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
                `

                closeButton.addEventListener('click', this.bottomSheet.close)

                return closeButton
            }

            createBottomSheet() {
                this.bottomSheet = window.BottomSheet.createBottomSheet({
                    content: `
                        <div class="modal-popup__top" id="bottom-sheet-top-bar-${this.sheetId}">
                            <div class="modal-popup__titles">
                                <h1>${this.title}</h1>
                                <h2>${this.subtitle}</h2>
                            </div>
                        </div>
                        <div class="modal-popup__content" id="bottom-sheet-content-${this.sheetId}" sheet-role="content">
                            ${this.richContext}
                        </div>
                    `,
                    defaultPosition: 'bottom',
                    dragTriggers: ['.modal-popup__content'],
                    expandable: true,
                    draggable: true,
                    snapPoints: [0.9, 0.6],
                    shouldCloseOnOutsideClick: true,
                    marginTop: 400,
                    afterOpen: () => {
                        document.querySelector('body').classList.add('bottom-sheet--no-overflow');
                        document.querySelector('html').classList.add('bottom-sheet--no-overflow');
                    },
                    afterClose: () => {
                        document.querySelector('body').classList.remove('bottom-sheet--no-overflow');
                        document.querySelector('html').classList.remove('bottom-sheet--no-overflow');
                    },
                });

                this.bottomSheet.elements.bottomSheetHandle.appendChild(this.createCloseButton())

                this.bottomSheet.mount();
                window.addEventListener('resize', () => {
                    this.bottomSheet.moveTo(30);
                });

                document.querySelector(`#bottom-sheet-opener--${this.sheetId}`)?.addEventListener('click', () => {
                    this.bottomSheet.open();
                });
            }

            connectedCallback() {
                this.sheetId = this.dataset.sheetId
                this.richContext = this.dataset.richContent
                this.title = this.dataset.title
                this.subtitle = this.dataset.subtitle
                this.closeText = this.dataset.closeText
                this.container = this
                this.bottomSheet = null

                const bottomSheetScript = document.getElementById("bottom-sheet-script")

                if (window.BottomSheet) {
                    this.createBottomSheet()
                } else {
                    bottomSheetScript?.addEventListener("load", this.createBottomSheet, { once: true })
                }
            }

            disconnectedCallback() {
                this.bottomSheet.unmount()
            }
        }
    );
}
